import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import IconTearDropButton from "../../../_utils/CommonButtons/IconTearDropButton";
import Chips from "../../CommonButtons/Chips";
import PrimaryWithIconButton from "../../CommonButtons/PrimaryWithIconButton";
import { toast } from "react-toastify";
import { toast_position } from "../../../../redux/features/Settings/Authorization";

const AssignLabels = ({
  setLabelpopup,
  labels,
  subText1,
  subText2,
  isOptional,
  previewMode = false,
  type,
}) => {
  const services = useSelector((state) => state.refreshToken.services);
  const hasALabel = services?.includes("ALabel");
  const hasRLabel = services?.includes("RLabel");
  const navigate = useNavigate();
  const isServiceMissing = !(hasALabel && hasRLabel);
  const handleLabelPopup = () => {
    if (isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ALabel,RLabel" },
      });
    } else {
      setLabelpopup(true);
    }
  };

  if (previewMode) {
    return (
      <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md gap-gap-md">
        <div className="text-text-primary text-font-md">
          <span className="font-semibold">Labels</span>
          {isOptional && <span className="font-normal"> (Optional)</span>}
        </div>

        <div>
          <div className="text-text-primary text-font-md">
            {labels.length === GlobalConfiguration?.lengthCheckZero ? (
              <div className="mb-margin-xs">Not assigned</div>
            ) : (
              <div className="mb-margin-xs">
                {labels.map((item, index) => (
                  <span
                    key={index}
                    className="break-all"
                  >
                    {item}
                    {index <
                      labels.length - GlobalConfiguration?.lengthCheckOne &&
                      ", "}
                  </span>
                ))}
              </div>
            )}
          </div>

          <div className="text-text-secondary text-font-xs font-normal">
            Labels
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col relative">
      <div className="p-padding-md h-height-full bg-primary-card flex flex-col rounded-border-radius-md">
        <div className="w-width-full flex flex-col gap-gap-md">
          <div className="flex justify-between items-start">
            <div className="flex flex-col gap-gap-xs">
              <div className="text-text-primary text-font-md">
                <span className="font-semibold">Labels</span>
                {isOptional && <span className="font-normal"> (Optional)</span>}
              </div>
              <div className="text-text-secondary text-font-xs">{subText1}</div>
            </div>

            {labels?.length > GlobalConfiguration.lengthCheckZero && (
              <div className="top-top-base right-right-base absolute">
                <IconTearDropButton
                  handleFunction={() => handleLabelPopup()}
                  isDisabled={false}
                  isLoading={false}
                  enabledBgColor={"var(--primary-nav-act)"}
                  icon={ICONS?.EDIT}
                  title="Edit"
                />
              </div>
            )}
          </div>
          {labels?.length > GlobalConfiguration.lengthCheckZero ? (
            <div>
              <p className="text-text-secondary text-font-xs">{subText2}</p>
              <div className="flex flex-wrap gap-gap-sm mt-margin-sm">
                {labels.map((item, index) => (
                  <Chips
                    txtChip={item}
                    enabledTextColor="var(--text-primary)"
                    enabledBgColor="var(--primary-nav)"
                  />
                  // <div
                  //   key={index}
                  //   className="bg-primary-nav text-text-primary px-padding-sm py-padding-xs rounded-full text-font-xs font-semibold flex items-center gap-gap-xs max-w-full"
                  // >
                  //   <span className="truncate min-w-0">{item}</span>
                  // </div>
                ))}
              </div>
            </div>
          ) : (
            <PrimaryWithIconButton
              btnText="Assign label"
              enabledBgColor="var(--primary-nav)"
              isDisabled={false}
              handleFunction={() => {
                if (type === "ffaccount") {
                  toast.info("Feature coming soon", toast_position);
                  return;
                }
                setLabelpopup(true);
              }}
              iconToBeAlign="left"
              enabledTextColor={"var(--text-primary)"}
              icon={ICONS?.LABEL}
              fullWidthRequired={true}
              hoverOption="white"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignLabels;
